export default __webpack_public_path__ + "static/piedra_deco_banner-2f9fabc8efa1548825ca70580c19d628.png";